// extracted by mini-css-extract-plugin
module.exports = {"social-proof":"SocialProof_social-proof__5kWWi"};